// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ContactAddressResourceViewModel from '../../../../viewModel/resource/ContactAddressResourceViewModel';
import CorrespondenceAddressResourceViewModel from '../../../../viewModel/resource/CorrespondenceAddressResourceViewModel';
import CorrespondenceAddressResourceDTO from '../../dto/resource/CorrespondenceAddressResourceDTO';

export default abstract class CorrespondenceAddressResourceModel extends BaseModel<CorrespondenceAddressResourceDTO> {
  /**
  * @type {int32}
  */
  get customerNumber() { return this.dto.customerNumber; }
  set customerNumber(value) { this.dto.customerNumber = value; }
  /**
  * @type {uuid}
  */
  get contactId() { return this.dto.contactId; }
  set contactId(value) { this.dto.contactId = value; }
  /**
  * @type {uuid}
  */
  get parentContactId() { return this.dto.parentContactId; }
  set parentContactId(value) { this.dto.parentContactId = value; }
  /**
  * @type {uuid}
  */
  get contactAccountId() { return this.dto.contactAccountId; }
  set contactAccountId(value) { this.dto.contactAccountId = value; }
  /**
  */
  get languageIso2() { return this.dto.languageIso2; }
  set languageIso2(value) { this.dto.languageIso2 = value; }
  /**
  */
  get address() { return this.getObjectModel(() => this.dto.address, ContactAddressResourceViewModel)!; }
  set address(value) { this.setObjectModel(() => this.dto.address, value); }
  /**
  */
  get isDifferentFromOwner() { return this.dto.isDifferentFromOwner; }
  set isDifferentFromOwner(value) { this.dto.isDifferentFromOwner = value; }
  /**
  */
  get isTrusteeAddress() { return this.dto.isTrusteeAddress; }
  set isTrusteeAddress(value) { this.dto.isTrusteeAddress = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.customernumber);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.customerNumber = value;
    this.dto.contactId = qs.contactid;
    this.dto.parentContactId = qs.parentcontactid;
    this.dto.contactAccountId = qs.contactaccountid;
    this.dto.languageIso2 = qs.languageiso2;
    value = qs.isDifferentFromOwner === 'true' ? true : qs.isdifferentfromowner;
    value = qs.isDifferentFromOwner === 'false' ? false : undefined;
    this.dto.isDifferentFromOwner = value;
    value = qs.isTrusteeAddress === 'true' ? true : qs.istrusteeaddress;
    value = qs.isTrusteeAddress === 'false' ? false : undefined;
    this.dto.isTrusteeAddress = value;
  }
}
